<template>
  <div>
    <px-view-header title="Cadastro de cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <v-stepper class="elevation-1" v-if="!loading" v-model="currentStep" vertical>
      <v-stepper-step :complete="currentStep > 1" step="1">
        Carga
      </v-stepper-step>
      <v-stepper-content step="1">
        <px-cadastro-cotacao-frete-carga :cotacao="cotacao"
                                         :is-copy="isCopy"
                                         :is-comprador="isComprador"
                                         @next="next"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 2" step="2">
        Transportadoras
      </v-stepper-step>
      <v-stepper-content step="2">
        <div>
          <px-cadastro-cotacao-frete-transportador v-if="currentStep === 2"
                                                   :cotacao="cotacao"
                                                   :loading-form="loadingForm"
                                                   @next="save"
                                                   @previous="previous"/>
        </div>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import { NumberUtils } from 'px-components';
import CadastroCotacaoFreteCarga from './CadastroCotacaoFreteCarga.vue';
import CadastroCotacaoFreteTransportador from './CadastroCotacaoFreteTransportador.vue';
import CotacaoFreteService from '../cotacao-frete-service';

const defaultVolume = () => ({
  quantidade: null,
  largura: null,
  comprimento: null,
  altura: null,
});

export default {
  data() {
    return {
      copiaId: this.$route.query.copia,
      currentStep: 1,
      type: this.$route.query.type,
      cotacao: {
        company: null,
        cepColeta: null,
        cpfCnpjColeta: null,
        municipioColeta: null,
        cepEntrega: null,
        cpfCnpjEntrega: null,
        municipioEntrega: null,
        localPagamento: null,
        quantidadeNotas: null,
        tipoMercadoria: null,
        pesoTotal: null,
        observacao: null,
        valorMercadoria: null,
        transportadoras: [],
        volumes: [defaultVolume()],
      },
      loading: false,
      loadingForm: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        {
          text: 'Cotações de frete',
          to: '/cotacoes-fretes',
        },
        { text: 'Cadastro de cotação' },
      ],
    };
  },
  computed: {
    isComprador() {
      return this.$pxFrete.isComprador;
    },
    isCopy() {
      return Boolean(this.copiaId);
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.gestao-frete.cotacoes' });
    },
    next() {
      this.currentStep = this.currentStep + 1;
    },
    previous() {
      this.currentStep = this.currentStep - 1;
    },
    buildPayload() {
      const cotacao = cloneDeep(this.cotacao);
      cotacao.cepColeta = onlyNumbers(cotacao.cepColeta);
      cotacao.cepEntrega = onlyNumbers(cotacao.cepEntrega);
      cotacao.cpfCnpjColeta = onlyNumbers(cotacao.cpfCnpjColeta);
      cotacao.cpfCnpjEntrega = onlyNumbers(cotacao.cpfCnpjEntrega);
      return cotacao;
    },
    save() {
      this.loadingForm = true;
      CotacaoFreteService.create(this.buildPayload())
        .then(() => {
          this.$toast('Cotação enviada', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    setupCopia(cotacao) { /* eslint-disable no-param-reassign */
      delete cotacao.id;
      delete cotacao.situacao;
      cotacao.transportadoras = [];
      cotacao.valorMercadoria = NumberUtils.fixNumberInput(cotacao.valorMercadoria);
      cotacao.volumes.forEach((v) => {
        delete v.id;
        v.largura = NumberUtils.fixNumberInput(v.largura);
        v.comprimento = NumberUtils.fixNumberInput(v.comprimento);
        v.altura = NumberUtils.fixNumberInput(v.altura);
      });
    },
    getCotacaoFrete() {
      this.loading = true;
      CotacaoFreteService.getCotacao(this.copiaId)
        .then(({ data }) => {
          this.setupCopia(data);
          this.cotacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.copiaId) {
      this.getCotacaoFrete();
    }
  },
  components: {
    pxCadastroCotacaoFreteCarga: CadastroCotacaoFreteCarga,
    pxCadastroCotacaoFreteTransportador: CadastroCotacaoFreteTransportador,
  },
};
</script>
